const Config = {
    Url: {
        BaseProduction:"https://x-pass-server.onrender.com",
        BaseLocal:"http://localhost:8458"
    }
}

export default Config;